import { jsx } from "react/jsx-runtime";
import {
  CardHeader,
  Typography,
  cardContentClasses,
  cardHeaderClasses,
  svgIconClasses
} from "@mui/material";
import { useCallback } from "react";
import { Wormhole } from "../../hooks/hooks/useWormhole/Wormhole.js";
import { useAppLauncherCard } from "./AppLauncherCardContextProvider.js";
const avatar = `.${cardHeaderClasses.avatar}`;
const headerText = `.${cardHeaderClasses.content}`;
const avatarIcon = `.${svgIconClasses.root}`;
const hasDescription = `:has(+ .${cardContentClasses.root})`;
function AppLauncherCardHeader(props) {
  const { icon, title } = props;
  const { cardId, disabled } = useAppLauncherCard();
  const target = `${cardId}-cardHeader`;
  const headerOverrides = useCallback(
    (theme) => ({
      paddingBottom: theme.spacing(2),
      opacity: disabled ? 0.5 : 1,
      [headerText]: {
        overflow: "hidden"
      },
      [hasDescription]: {
        paddingBottom: theme.spacing(1)
      },
      [avatar]: {
        marginRight: theme.spacing(0.25),
        [avatarIcon]: {
          height: theme.spacing(4),
          minWidth: theme.spacing(4)
        }
      }
    }),
    [disabled]
  );
  const typographyOverrides = useCallback(
    (theme) => ({
      opacity: disabled ? 0.5 : 1,
      color: disabled ? theme.vars.palette.text.disabled : theme.vars.palette.text.primary,
      // FIXME: Remove these after the subtitle3 and subtitle4 typographies are fixed: https://workwave.atlassian.net/issues/CUI-547
      fontFamily: theme.typography.subtitle2.fontFamily
    }),
    [disabled]
  );
  return /* @__PURE__ */ jsx(Wormhole, { target, children: /* @__PURE__ */ jsx(
    CardHeader,
    {
      avatar: icon,
      sx: headerOverrides,
      title: /* @__PURE__ */ jsx(Typography, { variant: "subtitle3", sx: typographyOverrides, noWrap: true, children: title })
    }
  ) });
}
export {
  AppLauncherCardHeader
};
//# sourceMappingURL=AppLauncherCardHeader.js.map
